import { useAuthQuery } from './auth'
import { ApiAgentRequest, request } from '../utils/request'
import { GetApplicationPagePropsResponse } from '@backend/agents-ui-api/routes/page-props/GET/types'

export type RawApplicationPagePropsResponse = GetApplicationPagePropsResponse

export function useGetApplicationPageProps() {
  const { isLoading, data } = useAuthQuery(['application-page-props'], async () => {
    return await request<RawApplicationPagePropsResponse>(
      new ApiAgentRequest('/page-props/', {
        method: 'GET',
      }),
      {
        isExpectedResponse: (res): res is RawApplicationPagePropsResponse => res as boolean,
      },
    )
  })

  return {
    isLoadingApplicationPageProps: isLoading,
    applicationPageProps: data?.data,
  }
}
